import React, { useState, useEffect } from 'react';
import { Card, Form, Button, Row, Col, Spinner } from 'react-bootstrap';
import { FaArrowDown, FaArrowUp } from 'react-icons/fa';

const TradingForm = ({ initialValues, onSubmit, isSaving }) => {
  const [formData, setFormData] = useState(initialValues || {});

  useEffect(() => {
    setFormData(initialValues || {});
  }, [initialValues]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) onSubmit(formData);
  };

  return (
    <Card>
      <Card.Header className="fw-semibold">Edit Strategy</Card.Header>
      <Card.Body>
        <Form onSubmit={handleSubmit}>

          {/* Symbol */}
          <Form.Group className="mb-4" controlId="symbol">
            <Form.Label className="fw-semibold">Ticker Symbol</Form.Label>
            <Form.Control
              type="text"
              name="symbol"
              value={formData.symbol || ''}
              onChange={handleChange}
              placeholder="e.g. AAPL"
              required
              style={{ maxWidth: 160 }}
            />
          </Form.Group>

          {/* BUY section */}
          <div className="d-flex align-items-center gap-2 mb-3">
            <FaArrowDown className="text-success" />
            <span className="fw-semibold">Buy Rules</span>
            <hr className="flex-grow-1 my-0" />
          </div>

          <Row className="g-3 mb-3">
            <Col sm={6}>
              <Form.Group controlId="ceiling">
                <Form.Label>Ceiling Threshold</Form.Label>
                <Form.Control
                  type="number"
                  name="ceiling"
                  value={formData.ceiling || ''}
                  onChange={handleChange}
                  required
                />
                <Form.Text className="text-muted">Max price to consider buying</Form.Text>
              </Form.Group>
            </Col>
            <Col sm={6}>
              <Form.Group controlId="floor">
                <Form.Label>Floor Threshold</Form.Label>
                <Form.Control
                  type="number"
                  name="floor"
                  value={formData.floor || ''}
                  onChange={handleChange}
                  required
                />
                <Form.Text className="text-muted">Min price to consider buying</Form.Text>
              </Form.Group>
            </Col>
          </Row>

          <Row className="g-3 mb-3">
            <Col sm={6}>
              <Form.Group controlId="lookBackDays">
                <Form.Label>Look Back Days</Form.Label>
                <Form.Control
                  type="number"
                  name="lookBackDays"
                  value={formData.lookBackDays || ''}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col sm={6}>
              <Form.Group controlId="focusDays">
                <Form.Label>Look Back Focus Days</Form.Label>
                <Form.Control
                  type="number"
                  name="focusDays"
                  value={formData.focusDays || ''}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="g-3 mb-3">
            <Col sm={6}>
              <Form.Group controlId="lookBackType">
                <Form.Label>Look Back Type</Form.Label>
                <Form.Select
                  name="lookBackType"
                  value={formData.lookBackType || ''}
                  onChange={handleChange}
                  required
                >
                  <option value="highest">Highest of focus days</option>
                  <option value="average">Average of highest and lowest in focus days</option>
                  <option value="lowest">Lowest of focus days</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col sm={6}>
              <Form.Group controlId="cheaperBuyPercent">
                <Form.Label>Cheaper Buy %</Form.Label>
                <Form.Control
                  type="number"
                  name="cheaperBuyPercent"
                  value={formData.cheaperBuyPercent || ''}
                  onChange={handleChange}
                  required
                />
                <Form.Text className="text-muted">Buy this % below lookback price</Form.Text>
              </Form.Group>
            </Col>
          </Row>

          {/* SELL section */}
          <div className="d-flex align-items-center gap-2 mb-3 mt-4">
            <FaArrowUp className="text-danger" />
            <span className="fw-semibold">Sell Rules</span>
            <hr className="flex-grow-1 my-0" />
          </div>

          <Row className="g-3 mb-4">
            <Col sm={6}>
              <Form.Group controlId="upSellPercent">
                <Form.Label>Take Profit %</Form.Label>
                <Form.Control
                  type="number"
                  name="upSellPercent"
                  value={formData.upSellPercent || ''}
                  onChange={handleChange}
                  required
                />
                <Form.Text className="text-muted">Sell when position gains this %</Form.Text>
              </Form.Group>
            </Col>
          </Row>

          <Button type="submit" variant="primary" disabled={isSaving}>
            {isSaving ? (
              <><Spinner animation="border" size="sm" className="me-2" />Saving…</>
            ) : (
              'Save Strategy'
            )}
          </Button>

        </Form>
      </Card.Body>
    </Card>
  );
};

export default TradingForm;
